// extracted by mini-css-extract-plugin
export var fileExt = "_v8-8";
export var fileIcon = "_v8-6";
export var fileLink = "_v8-5";
export var fileName = "_v8-7";
export var image = "_v8-1";
export var imageError = "_v8-3";
export var imageErrorIcon = "_v8-4";
export var imageLink = "_v8-0";
export var imageLoaded = "_v8-2";